import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { Product } from '../../../models/product.model';
import { OrderService } from '../../../services/order.service';
import { Order } from '../../../models/order.model';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { OrderTypes } from '../../../enums/order-types';
import { isEmptyArray } from '../../../shared/utils';

@UntilDestroy()
@Component({
  selector: 'products-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ProductsGridComponent implements OnInit {
  @Input() orderLookup = true;
  @Input() baseURI: string;
  @Input() activeOrder: Order;
  @Input() fetchingProducts = false;
  @Input() fetchedProducts = true;
  @Input() showNotFoundMessage = true;

  @BlockUI() blockUI: NgBlockUI;

  _products: Product[];
  private orderType: string; // defined by  product type

  @Input() set products(val: Product[]) {
    this._products = val;
    if (!isEmptyArray(this._products)) {
      this.orderType = this._products[0].isBuyingWindow
        ? OrderTypes.PREORDER_TYPE
        : OrderTypes.ECOMMERCE_TYPE;
    } else {
      this.orderType = null;
    }

    this.getActiveOrder();
  }

  constructor(private orderService: OrderService) {}

  ngOnInit() {
    // wait until order server is initialized
    if (this.orderLookup) {
      this.orderService.initialized$
        .pipe(untilDestroyed(this))
        .subscribe((data) => {
          if (data) {
            this.getActiveOrder();
          }
        });
    }
  }

  // if product is obsolete and not in the cart - should be hidden
  get activeProducts(): Product[] {
    if (isEmptyArray(this._products)) {
      return [];
    }

    if (!this.activeOrder) {
      // no active order - show all
      return this._products;
    }

    return this._products.filter((p) => {
      if (!p.obsolete) {
        return true;
      }
      return this.activeOrder.containsProduct(p);
    });
  }

  getActiveOrder() {
    if (!this.orderLookup) {
      return;
    }

    if (!this.orderType) {
      return;
    }

    setTimeout(() => {
      this.activeOrder =
        this.orderType === OrderTypes.PREORDER_TYPE
          ? this.orderService.activeBWOrder
          : this.orderService.activeODOrder;
    });
  }

  get hasProducts(): boolean {
    return this._products?.length > 0;
  }

  get notFoundProducts(): boolean {
    return this.fetchedProducts && !this.fetchingProducts && !this.hasProducts;
  }
}
